import type { WeatherData } from '@constants/types'
import { UPDATE_WEATHER_DATA } from '@store/actions'

interface WeatherAction {
  type: string
  payload: Partial<WeatherData>
}

const initialState: WeatherData = {
  weatherInfo: [],
  locations: [],
  isLoading: true
}

export default function init (previousState = initialState, { type, payload } : WeatherAction) {
  if (type === UPDATE_WEATHER_DATA) {
    return {
      ...previousState,
      weatherInfo: payload.weatherInfo ?? previousState.weatherInfo,
      locations: payload.locations ?? previousState.locations,
      isLoading: payload.isLoading ?? previousState.isLoading
    }
  } else {
    return previousState
  }
}
